import {Local, Session} from './storage';

const ACTIVITYTOKEN = 'token';
const PROJECID = 'projectId';
const ASSESSTYPE = 'assessType';
const ASSESSID = 'assessId';
const CHILDID = 'childId';
const ISLOGIN = 'isLogin';
const USERID = 'userId';
const RECOMMENDID = 'recommendId';

function getAuthToken() {
  return Session.get(ACTIVITYTOKEN);
}

function setAuthToken(token) {
  return Session.set(ACTIVITYTOKEN, token);
}

function removeAuthToken() {
  return Session.remove(ACTIVITYTOKEN);
}
function getUserId() {
  return Session.get(USERID);
}

function setUserId(uerId) {
  return Session.set(USERID, uerId);
}

function removeUserId() {
  return Session.remove(USERID);
}

function getProjectId() {
  return Session.get(PROJECID);
}

function setProjectId(id) {
  return Session.set(PROJECID, id);
}

function removeProjectId() {
  return Session.remove(PROJECID);
}

function getAssessType() {
  return Session.get(ASSESSTYPE);
}

function setAssessType(type) {
  return Session.set(ASSESSTYPE, type);
}

function removeAssessType() {
  return Session.remove(ASSESSTYPE);
}
function getAssessId() {
  return Session.get(ASSESSID);
}

function setAssessId(id) {
  return Session.set(ASSESSID, id);
}

function removeAssessId() {
  return Session.remove(ASSESSID);
}

function getChildId() {
  return Session.get(CHILDID);
}

function setChildId(childId) {
  return Session.set(CHILDID, childId);
}

function removeChildId() {
  return Session.remove(CHILDID);
}
function getisLogin() {
  return Session.get(ISLOGIN);
}

function setisLogin(isLogin) {
  return Session.set(ISLOGIN, isLogin);
}

function removeisLogin() {
  return Session.remove(ISLOGIN);
}
function getRecommendId() {
  return Session.get(RECOMMENDID);
}

function setRecommendId(recommendId) {
  return Session.set(RECOMMENDID, recommendId);
}

function removeRecommendId() {
  return Session.remove(RECOMMENDID);
}

export {
  getAuthToken,
  setAuthToken,
  removeAuthToken,
  getUserId,
  setUserId,
  removeUserId,
  getProjectId,
  setProjectId,
  removeProjectId,
  getAssessType,
  setAssessType,
  removeAssessType,
  getAssessId,
  setAssessId,
  removeAssessId,
  getChildId,
  setChildId,
  removeChildId,
  getisLogin,
  setisLogin,
  removeisLogin,
  getRecommendId,
  setRecommendId,
  removeRecommendId
};



// WEBPACK FOOTER //
// ./src/js/util/auth.js